import { useRef } from 'react';

interface UseHorizontalSwipeOptions {
  onSwipe?: () => void;
  threshold?: number;
  disabled?: boolean;
}

export const useHorizontalSwipe = ({
  onSwipe,
  threshold = 50,
  disabled = false,
}: UseHorizontalSwipeOptions) => {
  const touchStart = useRef({ x: 0, y: 0 });

  const handleTouchStart = (event: React.TouchEvent) => {
    if (disabled) return;
    const touch = event.touches[0];
    touchStart.current = { x: touch.clientX, y: touch.clientY };
  };

  const handleTouchEnd = (event: React.TouchEvent) => {
    if (disabled) return;

    const touch = event.changedTouches[0];
    const deltaX = Math.abs(touch.clientX - touchStart.current.x);
    const deltaY = Math.abs(touch.clientY - touchStart.current.y);

    if (deltaX > deltaY && deltaX >= threshold) {
      onSwipe?.();
    }
  };

  return {
    onTouchStart: handleTouchStart,
    onTouchEnd: handleTouchEnd,
  };
};
